import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { ExportAssetNamePopup } from './ExportAssetNamePopup';

const POPUP_KEY = Symbol('EXPORT_ASSET_NAME');

export const useExportAssetNamePopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(POPUP_KEY, ExportAssetNamePopup);
  });

  const openExportAssetNamePopup = useCallback(() => {
    return new Promise((resolve) => {
      popups.openPopup(POPUP_KEY, {
        onSubmit: (value) => {
          popups.closePopup(POPUP_KEY);
          resolve(value);
        },
        onCancel: () => {
          popups.closePopup(POPUP_KEY);
          resolve(null);
        },
      });
    });
  }, [popups]);

  return { openExportAssetNamePopup };
};
